import { createApp } from "vue";
import "@/style.css";
import App from "@/App.vue";
import { createPinia } from 'pinia';
import packageJSON from '../package.json';

declare global {
  interface Window {
    startDSAWidget?: () => void;
    // __DSA_WIDGET_ENV__?: string;
    // __DSA_WIDGET_CONFIG__?: {
    //   mode: string;
    //   apiUrl?: string;
    // };
  }
}

// window.__DSA_WIDGET_ENV__ = import.meta.env.MODE;
// window.__DSA_WIDGET_CONFIG__ = {
//   mode: import.meta.env.MODE,
//   apiUrl: import.meta.env.VITE_DSA_API_URL,
// };

function mountAPP() {
  const container = document.querySelector("#dsa-widget") as (HTMLElement & { __vue_app__?: unknown }) | null;

  if (!container) {
    console.error('DSA Widget - Container #dsa-widget not found. Add <div id="dsa-widget"> to your page.');
    return;
  }

  // Guard: nie montuj dwa razy na tym samym wrapperze
  if (container.__vue_app__) {
    return;
  }

  const service = container.getAttribute('data-service') || 'gazeta_pl';
  const version = packageJSON.versionTest || packageJSON.version || '0.0.0';
  const app = createApp(App, { service, version });
  const pinia = createPinia();
  app.use(pinia);
  app.mount(container);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", mountAPP);
} else {
  mountAPP();
}

window.startDSAWidget = mountAPP;